import { Slideshow } from './slideshow.js';

class SlideshowMtc extends Slideshow {
  static get observedAttributes() {
    return [...super.observedAttributes, 'autoplay'];
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.autoplay) {
      this.play();
    }
    
    this.addEventListener('pointerdown', () => this.suspend());
    this.addEventListener('pointerup', () => this.resume());
    this.addEventListener('focusin', () => this.suspend());
    this.addEventListener('focusout', () => this.resume());

    // Initialize activation logic
    const breakpoint = this.dataset.mobileBreakpoint || 750;
    this.matchMedia = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    
    this.handleActivationChange = (e) => {
      if (e.matches) {
        this.classList.add('slideshow--activated');
        this.classList.remove('slideshow--deactivated');
      } else {
        this.classList.remove('slideshow--activated');
        this.classList.add('slideshow--deactivated');
      }
    };

    // Initial check
    this.handleActivationChange(this.matchMedia);

    // Listen for changes
    this.matchMedia.addEventListener('change', this.handleActivationChange);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.matchMedia && this.handleActivationChange) {
      this.matchMedia.removeEventListener('change', this.handleActivationChange);
    }
  }

  get autoplayInterval() {
    const interval = this.getAttribute('autoplay');
    if (!interval) return undefined;
    
    let value = parseInt(interval, 10);
    if (isNaN(value)) return undefined;

    if (value < 1000) {
        return value * 1000;
    }
    return value;
  }
}

if (!customElements.get('slideshow-mtc')) {
  customElements.define('slideshow-mtc', SlideshowMtc);
}
